angular.module('unergie.main')
.controller('perimeterValidationCtrl', ($scope, $timeout, $filter, $stateParams, MS, NgTableParams, DataAccess, CommonRegex, PrmValidationConstants, AuthService, PrmUtilsService, ModalService,
    ApiUser, FileUploader, DataAccessSearch, AlertManager, MetaWatcher, BoFeaturesService, ContactInformationB2G, ContractConstants, ErrorCatcher) => {
    const validationFeatures = BoFeaturesService.getModuleFeatures('validation')
    $scope.canMigratePDL = validationFeatures.canMigratePDL
    $scope.selected = {}
    $scope.validation = {}
    $scope.warningMessages = []
    $scope.errorMessages = []

    $scope.selectedOrg = undefined

    $scope.isAdmin = BoFeaturesService.isFeatureOn('validationAdmin')

    $scope.affectableAccountsByOrg = {}

    $scope.isPrmValid = PrmUtilsService.isPrmValid
    $scope.crossOrg = BoFeaturesService.isFeatureOn('crossOrg')

    $scope.isEnedisKo = (prm) => PrmValidationConstants.KO_ENEDIS_STATUSES.includes(prm.enedis_status)

    $scope.orgContacts = ContactInformationB2G

    const PRM_FIELDS_TO_CHECK = [
        'cluster.brand',
        'label',
        'category',
        'technical_civ',
        'technical_givenname',
        'technical_sn',
        'technical_phone',
        'technical_mail',
        'desired_mes_date',
        'status',
        'comments',
        'choosen_id_p_calendar',
        'choosen_routing_tariff',
        'choosen_max_power',
        'choosen_temp_class_powers.HCE',
        'choosen_temp_class_powers.HCH',
        'choosen_temp_class_powers.HPE',
        'choosen_temp_class_powers.HPH',
        'choosen_temp_class_powers.PTE',
        'chosen_phase',
    ]

    const CLUSTER_FIELDS_TO_CHECK = [
        'civ',
        'givenname',
        'sn',
        'phone',
        'mail',
        'siret',
        'addr_city_lbl',
        'addr_num_street',
        'addr_post_code',
        'secondary_civ',
        'secondary_givenname',
        'secondary_sn',
        'secondary_phone',
        'secondary_mail',
        'principal_civ',
        'principal_givenname',
        'principal_sn',
        'principal_phone',
        'principal_mail',
        'other_civ',
        'other_givenname',
        'other_sn',
        'other_phone',
        'other_mail',
        'se_code',
        'ej_code',
        'imputation_code',
        'payment_mode',
        'payment_frequency',
        'energy_type',
        'id_agreement_elec',
        'id_agreement_gas',
    ]

    $scope.popupValidationFields = {
        title: {
            label: 'Récapitulatif :',
            type: 'label',
        },
        principalContacts: {
            label: () => {
                const principalContacts = _($scope.selected.account.clusters)
                .map((c) => _(c).pick(['principal_role', 'principal_mail', 'principal_phone']).values().compact().join(' '))
                .compact()
                .uniq()
                .value()
                if (_.isEmpty(principalContacts)) {
                    return '&ndash;&nbsp;Aucun contact principal enregistré'
                } else if (principalContacts.length === 1) {
                    return `&ndash;&nbsp;Contact principal enregistré : ${principalContacts[0]}`
                }
                return `&ndash;&nbsp;${principalContacts.length} contacts principaux différents enregistrés`
            },
            type: 'label',
        },
        billingContacts: {
            label: () => {
                const billingContacts = _($scope.selected.account.clusters)
                .map((c) => _(c).pick(['role', 'mail', 'phone']).values().compact().join(' '))
                .compact()
                .uniq()
                .value()
                if (_.isEmpty(billingContacts)) {
                    return '&ndash;&nbsp;Aucun contact de facturation enregistré'
                } else if (billingContacts.length === 1) {
                    return `&ndash;&nbsp;Contact de facturation enregistré : ${billingContacts[0]}`
                }
                return `&ndash;&nbsp;${billingContacts.length} contacts de facturation différents enregistrés`
            },
            type: 'label',
        },
        technicalContacts: {
            label: () => {
                const perimeterTechnicalContacts = _($scope.selected.account.perimeter)
                .map((c) => _(c).pick(['technical_mail', 'technical_phone']).values().compact().join(' '))
                .compact()
                .uniq()
                .value()
                if (_.isEmpty(perimeterTechnicalContacts)) {
                    return '&ndash;&nbsp;Aucun contact technique enregistré'
                } else if (perimeterTechnicalContacts.length === 1) {
                    return `&ndash;&nbsp;Contact technique enregistré : ${perimeterTechnicalContacts[0]}`
                }
                return `&ndash;&nbsp;${perimeterTechnicalContacts.length} contacts techniques différents enregistrés`
            },
            type: 'label',
        },
        clustersTotalNumber: {
            label: () => {
                if (_.isEmpty($scope.selected.account.clusters)) {
                    return `&ndash;&nbsp;Aucun paquet facturier enregistré`
                } else if ($scope.selected.account.clusters.length === 1) {
                    return `&ndash;&nbsp;1 paquet facturier enregistré`
                }
                return `&ndash;&nbsp;${$scope.selected.account.clusters.length} paquets facturiers enregistrés au total`
            },
            type: 'label',
        },
        clustersByPaymentMode: {
            hidden: () => _.isEmpty($scope.selected.account.clusters),
            label: () => {
                const clustersByPaymentMode = _($scope.selected.account.clusters)
                .countBy('payment_mode')
                .map((v, k) => `${v} paquet${v > 1 ? 's' : ''} facturier${v > 1 ? 's' : ''} en ${$filter('billPaymentMode')(k)}`)
                .join(', ')
                return `&ndash;&nbsp;dont ${clustersByPaymentMode}`
            },
            type: 'label',
        },
        clustersByEnergyType: {
            hidden: () => _.isEmpty($scope.selected.account.clusters),
            label: () => {
                const clustersByEnergyType = _($scope.selected.account.clusters)
                .countBy('energy_type')
                .map((v, k) => `${v} paquet${v > 1 ? 's' : ''} facturier${v > 1 ? 's' : ''} avec ${$filter('billEnergyType')(k)}`)
                .join(', ')
                return `&ndash;&nbsp;dont ${clustersByEnergyType}`
            },
            type: 'label',
        },
        label: {
            label: 'Je confirme que :',
            type: 'label',
        },
        ownPrms: {
            label: 'L’intégralité des points de livraison appartiennent à mon périmètre',
            type: 'checkbox',
            check: (template) => template.ownPrms,
        },
        prmsRepartition: {
            label: 'Les points de livraison sont correctement répartis dans les regroupements facturiers (non modifiable après la bascule) ',
            type: 'checkbox',
            check: (template) => template.prmsRepartition,
        },
        factuSettings: {
            label: 'Les modalités de facturation, y compris la fréquence et le mode de paiement, sont exactes (non modifiable après la bascule)',
            type: 'checkbox',
            check: (template) => template.factuSettings,
        },
        transitionDate: {
            label: 'La date de bascule de chaque point de livraison est correcte',
            type: 'checkbox',
            check: (template) => template.transitionDate,
        },
    }

    $scope.popupValidationTemplate = {}

    const phoneRegexAll = CommonRegex.phone.french

    $scope.stopProp = (e) => {
        e.stopPropagation()
    }

    $scope.spinners = {
        nbPrm: false,
    }

    const reminderFieldsTemplate = {
        label: {
            label: (a) => `Un e-mail de relance de validation du périmètre sera envoyé au(x) destinataire(s) suivant(s) :`,
            type: 'label',
        },
    }

    $scope.reminderPayload = {}
    $scope.reminderFields = {}

    $scope.prepareReminderPayload = (account) => {
        $scope.reminderPayload = { account }
        $scope.reminderFields = _.cloneDeep(reminderFieldsTemplate)
        _.each(account.affectedAccounts, (a) => {
            $scope.reminderPayload[a.id] = (a.organization === account.organization && a.id !== AuthService.getAuth().uuid)
            // TODO this is a quickfix to stop displaying too much potential recipients, make something cleaner ...
            if (account.organization != 'smed13' || (a.organization != 'plum')) {
                $scope.reminderFields[a.id] = {
                    label: a.mail,
                    type: 'checkbox',
                }
            }
        })
    }

    $scope.sendReminder = () => {
        const accounts = _.filter(_.map($scope.reminderPayload, (value, key) => (value === true) && key))
        return ApiUser.sendPerimeterReminder({ id_account: $scope.reminderPayload.account.id }, accounts).$promise.then((result) => {
            AlertManager.success(result.message, 10000)
        }).catch(ErrorCatcher)
    }

    $scope.refreshAccount = (account) => {
        if (account) {
            $scope.selected.account = account
        }
        MetaWatcher.notif('MNG_ACCOUNT_CHANGED')
    }

    const addErrorMsg = (sentence, type, list) => {
        if (list.length) {
            let msg = `${sentence}`
            msg += `, ${type}(s) concerné(s) :<ul>`
            _.each(list, (l) => {
                msg += `<li>${l}</li>`
            })
            msg += `</ul>`
            $scope.errorMessages.push(msg)
        }
    }

    const handleDuplicateClusters = (clusters) => {
        const grouped = _.groupBy(clusters, (c) => c.brand.toUpperCase())
        const dupes = []
        _.each(grouped, (declared, brand) => {
            if (declared && declared.length && declared.length > 1) {
                declared.shift()
                _.each(declared, (d) => {
                    d.duplicate = true
                    dupes.push(d.brand)
                })
            }
        })
        addErrorMsg(`Il existe des groupements facturiers déclarés en double dans l'onglet "3.Infos Facture(s)"`, 'groupement', dupes)
    }

    const handleUncheckedPdl = (incomplete) => {
        const unlinked = _.map(_.filter(incomplete, (i) => {
            // on filtre sur les pdl qui ont une facture référencées et qui n'ont pas le status 'validé'
            // ou sur ceux qui sont validés sans avoir de facture associée
            return i.status === 'AFFECTED' && !(i.cluster && i.cluster.brand)
        }), 'id_prm')
        addErrorMsg(`Tous les points "Validés" (colonne "Statut de validation du PRM") doivent être liés à un groupement facturier`, 'point', unlinked)
    }

    const checkDelete = (item, fields) => {
        let deletes = false
        if (item.previous) {
            _.each(fields, (f) => {
                if (item.previous[f] && !item[f]) {
                    deletes = true
                }
            })
        }
        return deletes
    }

    const handleCluster = (clusters) => {
        _.each(clusters, (c) => {
            _.each(['', 'principal_', 'secondary_', 'other_'], (type) => {
                if (c[`${type}civ`] && c[`${type}sn`] && c[`${type}givenname`] && (c[`${type}phone`] && phoneRegexAll.test(c[`${type}phone`]))) {
                    c[`${type}contact_ok`] = true
                } else {
                    c[`${type}contact_ok`] = false
                }
            })
            c.complete = c.contact_ok && c.principal_contact_ok && c.siret && c.addr_num_street && c.addr_post_code && c.addr_city_lbl && c.energy_type != null && c.payment_mode && c.payment_frequency
            c.address = `${c.addr_num_street} ${c.addr_post_code} ${c.addr_city_lbl}`
            c.nbPrm = _.sumBy($scope.importedPdls, (p) => ((p.cluster && p.cluster.brand === c.brand) ? 1 : 0))
        })
        addErrorMsg(`Tous les groupements facturiers doivent avoir à minima un contact principal`, 'groupement', _.map(_.filter(clusters, { principal_contact_ok: false }), 'brand'))
        addErrorMsg(`Tous les groupements facturiers doivent avoir à minima un contact de facturation`, 'groupement', _.map(_.filter(clusters, { contact_ok: false }), 'brand'))
        const siretOrExternalIdModifs = _.filter(clusters, (c) => {
            return (c.siret && c.previous && c.previous.siret && c.siret !== c.previous.siret) ||
                (c.external_id && c.previous && c.previous.external_id && c.external_id !== c.previous.external_id)
        })
        addErrorMsg(`Pour éviter toutes collisions, il est impossible de modifier le "SIRET" ou "le Code de la facture" d'un groupement :` +
            ` merci de changer le libellé du groupement`, 'groupement', _.map(siretOrExternalIdModifs, 'brand'))
        const noReimbursement = _.filter(clusters, (c) => c.report_reimbursement == null)
        addErrorMsg(`Tous les groupements facturiers doivent avoir la gestion des avoirs renseignée`, 'groupement', _.map(noReimbursement, 'brand'))
        const noEnergyType = _.filter(clusters, (c) => c.energy_type == null)
        addErrorMsg(`Tous les groupements facturiers doivent avoir la part d'énergie renouvelable renseignée`, 'groupement', _.map(noEnergyType, 'brand'))
        const noPaymentMode = _.filter(clusters, (c) => c.payment_mode == null)
        addErrorMsg(`Tous les groupements facturiers doivent avoir le mode de paiement renseigné`, 'groupement', _.map(noPaymentMode, 'brand'))
        const inconsistentPaymentModes = _.uniqBy(_.filter(clusters, (c) => c.paymentModeCheck && c.paymentModeCheck.status === 'ERROR'),
            (c) => `${c.siret}#${c.id_agreement_elec || c.id_agreement_gas}`)
        addErrorMsg(`Tous les paquets avec le même SIRET doivent déclarer le même mode de paiement au sein d'un même marché`, 'groupement',
            _.map(inconsistentPaymentModes, (c) => `${c.siret} - marché ${c.id_agreement_elec || c.id_agreement_gas} - ${c.paymentModeCheck.message}`))
        addErrorMsg(`Tous les groupements facturiers doivent avoir le marché renseigné`, 'groupement', _.map(_.filter(clusters, (c) => !c.id_agreement_elec), 'brand'))
        addErrorMsg(`Tous les SIRET doivent être connus de l'INSEE${$scope.selectedOrgObject.type === 'B2G' ? ' (ou a minima de CHORUS)' : ''} et être actifs`, 'siret',
            _.uniq(_.map(_.filter(clusters, (c) => !c.siretValidationResult || !c.siretValidationResult.active), 'siret')))
    }

    const checkPdlLink = (pdls) => {
        _.each(pdls, (pdl) => {
            if (pdl.cluster && pdl.cluster.brand) {
                const existing = _.find($scope.response.clusters, (c) => pdl.cluster.brand.toUpperCase() === c.brand.toUpperCase())
                pdl.cluster.existing = !!existing
                pdl.cluster.complete = !!(existing && existing.complete)
            }
        })
    }

    const parseResponse = (response) => {
        $scope.response = response
        $scope.errorMessages = []
        $scope.warningMessages = []
        $scope.importedClusters = _.compact(_.map(response.clusters, (c) => c.brand && c.brand.toUpperCase()))
        $scope.importedPdls = _.concat(response.new, response.incomplete, response.excluded, response.validated)
        $scope.referencedClusters = _.compact(_.uniq(_.map($scope.importedPdls, 'cluster.brand')))
        $scope.undeclaredClusters = _.filter($scope.referencedClusters, (r) => !$scope.importedClusters.includes(r.toUpperCase()))
        addErrorMsg(`Tous les groupements facturiers référencés dans l'onglet "2.Infos Point(s) de Livraison" doivent être renseignés dans l'onglet "3.Infos Facture(s)"`,
            'groupement',
            $scope.undeclaredClusters)
        addErrorMsg(`Tous les points validés doivent avoir une date de mise en service valide`,
            'points',
            _.map(_.filter($scope.importedPdls, (i) => i.status === 'AFFECTED' && (!i.desired_mes_date || !moment(i.desired_mes_date).isValid())), 'id_prm'))
        addErrorMsg(`Les points avec le statut Enedis : "${PrmValidationConstants.KO_ENEDIS_STATUSES.join('", "')}" doivent être exclus du périmètre.`,
            'points',
            _.map(_.filter($scope.importedPdls, (i) => i.status !== 'EXCLUDED' && PrmValidationConstants.KO_ENEDIS_STATUSES.includes(i.enedis_status)), (p) => {
                let msg = `${p.id_prm}`
                msg += p.message ? ` - ${p.message.replace('commande@plum.fr', 'B2G@plum-energie.com')}` : ''
                msg += p.detail ? ` (${p.detail})` : ''
                return msg
            }))
        addErrorMsg(`Pour éviter toute confusion les PDL exclus ne doivent pas être associés à une facture. ` +
            `Merci de laisser vide la case « Libellé de facture » (de l'onglet « Info Points de Livraison »)`,
        'points',
        _.map(_.filter($scope.importedPdls, (i) => i.status === 'EXCLUDED' && _.get(i, 'cluster.brand')), 'id_prm'))
        // checkEligibility(response.new)
        handleDuplicateClusters(response.clusters)
        handleCluster(response.clusters)
        handleUncheckedPdl(_.concat(response.incomplete, response.new))
        checkPdlLink($scope.importedPdls)
        const deletes = _.concat(_.filter(response.clusters, (c) => checkDelete(c, CLUSTER_FIELDS_TO_CHECK)), _.filter($scope.importedPdls, (p) => checkDelete(p, PRM_FIELDS_TO_CHECK)))
        if (deletes.length) {
            $scope.warningMessages.push(`Néanmoins la validation de votre import semble supprimer des informations existantes. Pour éviter tout problème, ` +
                `ces suppressions ne seront pas répercutées dans notre base de données. Si vous désirez effectivement supprimer ces informations, merci de créer un ticket en renseignant ` +
                `le numéro de PDL ou le libellé de la facture, ainsi que les informations à supprimer.`)
        }
        $scope.parseResult = _.mapValues(response, (value, key) => {
            if (['clusters'].includes(key)) {
                return value
            }
            return new NgTableParams({}, { dataset: value })
        })
        if ($scope.parseResult) {
            setTimeout(() => { window.scrollTo(0, window.scrollY + document.getElementById('validate-after-import').getBoundingClientRect().y) })
        }
    }

    $scope.getTechnicalContact = (o) => {
        if (!o.previous) {
            return `${o.technical_civ || ''} ${o.technical_givenname || ''} ${o.technical_sn || ''}` +
                `${o.technical_phone ? ` (${$filter('phone')(o.technical_phone)})` : '<span class="red">Info manquante</span>'}` +
                `${o.technical_mail ? ` - ${o.technical_mail}` : ''}`
        }
        return `<span class="${o.technical_civ !== o.previous.technical_civ ? 'orange' : ''}">${o.technical_civ || ''}</span>` +
            ` <span class="${o.technical_givenname !== o.previous.technical_givenname ? 'orange' : ''}">${o.technical_givenname || ''}</span>` +
            ` <span class="${o.technical_sn !== o.previous.technical_sn ? 'orange' : ''}">${o.technical_sn || ''}</span>` +
            `${o.technical_phone ? ` (<span class="${o.technical_phone !== o.previous.technical_phone ? 'orange' : ''}">${$filter('phone')(o.technical_phone)}</span>)` :
                '<span class="red">Info manquante</span>'}` +
            `${o.technical_mail ? ` - <span class="${o.technical_mail !== o.previous.technical_mail ? 'orange' : ''}">${o.technical_mail || ''}</span>` : ''}`
    }

    $scope.perimeterUploader = new FileUploader({
        url: `/api-user/pdl-perimeter/upload-xlsx`,
        alias: 'file',
        formData: [{ id_account: $scope.selected.account && $scope.selected.account.id }],
        autoUpload: true,
        method: 'POST',
        onBeforeUploadItem() {
            $scope.response = null
            $scope.parseResult = null
        },
        onSuccessItem(item, response, status, headers) {
            AlertManager.success(`Périmètre importé`)
            parseResponse(response)
        },
        onErrorItem(item, response, status, headers) {
            AlertManager.error(response.message, 10000)
        },
    })

    const fetchAccountInfo = () => {
        $scope.selected.account.fetching = true
        return DataAccess.myAccount({ id: $scope.selected.account.id }).$promise
        .then((accountDetails) => {
            const account = accountDetails.toJSON()
            handleCluster(account.clusters)
            _.each(account.clusters, (c) => {
                c.nbPrm = _.sumBy(account.perimeter, (p) => ((p.id_cluster && p.id_cluster === c.id) ? 1 : 0))
            })
            _.each(account.perimeter, (p) => {
                if (p.id_cluster) {
                    const c = _.find(account.clusters, { id: p.id_cluster })
                    if (c) {
                        p.cluster = _.pick(c, ['brand', 'complete', 'validated'])
                    }
                }
                if (p.status === 'TRANSFORMED') {
                    p.validationStatus = 'Point intégré'
                    p.validationClass = 'green'
                    p.order = 6
                } else if (p.status === 'EXCLUDED') {
                    p.validationStatus = 'Exclu du marché'
                    p.validationClass = 'green'
                    p.order = 5
                } else if (p.validated && p.cluster && p.cluster.validated) {
                    p.validationStatus = 'Validé'
                    p.validationClass = 'green'
                    p.order = 4
                } else if (p.cluster && !p.cluster.validated) {
                    p.validationStatus = 'Infos facture incomplètes'
                    p.validationClass = 'orange'
                    p.order = 2
                } else if (p.cluster && p.status === 'UNAFFECTED') {
                    p.validationStatus = 'Statut non renseigné'
                    p.validationClass = 'orange'
                    p.order = 1
                } else if (p.cluster) {
                    p.validationStatus = 'Infos point incomplets'
                    p.validationClass = 'orange'
                    p.order = 1
                } else {
                    p.validationStatus = 'Non affecté'
                    p.order = 3
                }
            })
            account.perimeter = _.orderBy(account.perimeter, ['order', 'id_prm'], ['asc', 'asc'])
            _.assign($scope.selected.account, account)
            $scope.selected.clusters = account.clusters
            $scope.selected.perimeter = new NgTableParams({}, { dataset: account.perimeter })
            $scope.selected.account.siretsNeedingIban = _.filter($scope.selected.account.sirets, { active: true })
            $scope.selected.account.unKnownsirets = _.filter($scope.selected.account.sirets, (siret) => !siret.active)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.selected.account.fetching = false
        })
    }

    const updateAccount = () => {
        if ($scope.selected.account) {
            fetchAccountInfo()
            $scope.perimeterUploader.formData = [{ id_account: $scope.selected.account.id }]
            $scope.parseResult = undefined
        }
    }

    $scope.updatePage = () => {
        const selectedId = ($scope.selected.account && $scope.selected.account.id) || $stateParams.id_account
        $scope.updatingPage = true
        return ($scope.selectedOrg ? Promise.resolve($scope.selectedOrg) : DataAccess.myOrganizations().$promise
        .then((myOrganizations) => {
            $scope.organizations = myOrganizations
            if (myOrganizations.length === 1) {
                $scope.selectedOrg = myOrganizations[0]
                return myOrganizations[0].id
            }
        }))
        .then((organization) => {
            if (organization) {
                $scope.selectedOrgObject = _.find($scope.organizations, { id: organization })
                $scope.orgContact = _.assign({}, $scope.orgContacts[`default_${$scope.selectedOrgObject.type}`], $scope.selectedOrgObject.contact_infos)
                return DataAccess.myAccounts({ organization }).$promise
                .then((accounts) => {
                    $scope.accounts = accounts
                    if (!selectedId) {
                        $scope.selected = {
                            account: $scope.accounts[0],
                        }
                    } else {
                        $scope.selected = {
                            account: _.find($scope.accounts, { id: selectedId }),
                        }
                    }
                    if ($scope.accounts.length > 1 || $scope.isAdmin) {
                        $scope.accountsTable = new NgTableParams({}, { dataset: $scope.accounts })
                        const total = _.sumBy(accounts, 'validation.total')
                        const validated = _.sumBy(accounts, 'validation.validated')
                        $scope.validation = {
                            total,
                            validated,
                            percent: MS.round((100 * validated) / total, 2),
                        }
                    }
                    if ($scope.canMigratePDL) {
                        $scope.affectableAccountsByOrg = _.groupBy(_.map($scope.accounts, (a) => ({ value: a.id, label: a.brand, organization: a.organization })), 'organization')
                    }
                    updateAccount()
                })
                .catch(ErrorCatcher)
            }
        })
        .finally(() => {
            $scope.updatingPage = false
        })
    }

    $scope.canValidate = () => {
        return (!$scope.undeclaredClusters || !$scope.undeclaredClusters.length) && !$scope.errorMessages.length && (!$scope.response || !$scope.response.sirets || !$scope.response.sirets.length)
    }

    const checkNoModifs = (provided, existing) => {
        let equal = true
        _.each(PRM_FIELDS_TO_CHECK, (f) => {
            const [val1, val2] = [_.get(provided, f), _.get(existing, f)]
            if (!val1 && !val2) {
                return true
            }
            equal = (`${val1}` === `${val2}`)
            return equal
        })
        return equal
    }

    $scope.reCheckSiret = (siret) => {
        siret.refreshing = true
        return ApiUser.validateSiret({ siret: siret.siret, source: 'ALL', store: true }).$promise
        .then((siretValidationResult) => {
            if (siretValidationResult.active) {
                AlertManager.success(`Le SIRET correctement récupéré : il appartient à : ${siretValidationResult.legal_name}, ` +
                    `${siretValidationResult.bill_addr_num_street} ${siretValidationResult.bill_addr_post_code} ${siretValidationResult.bill_addr_city_lbl}`)
                MetaWatcher.notif('MNG_ACCOUNT_CHANGED')
            } else {
                AlertManager.error(`SIRET inactif, source : ${siretValidationResult.source}`)
            }
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $timeout(() => {
                siret.refreshing = false
            })
        })
    }

    $scope.validatePerimeter = (noMail) => {
        $scope.validatingPerimeter = true
        const payload = $scope.response
        payload.validated = _.filter(payload.validated, (v) => !v.previous || !checkNoModifs(v, v.previous))
        return ApiUser.validatePerimeter({ id_account: $scope.selected.account.id, noMail }, payload).$promise
        .then((result) => {
            AlertManager.success(`Périmètre validé`, 10000)
            $scope.updatePage()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.validatingPerimeter = false
        })
    }

    $scope.validatePerimeterAsIs = () => {
        $scope.validatingPerimeterAsIs = true
        return ApiUser.validatePerimeterAsIs({ id_account: $scope.selected.account.id }, {}).$promise
        .then((result) => {
            let message = `Périmètre validé à ${result.pdls.ratio} %`
            let alertMethod = 'success'
            if (result.pdls.ratio !== 100) {
                message += `. Il manque certaines informations pour pouvoir valider entièrement votre périmètre, merci de compléter les informations via l'Excel.`
                alertMethod = 'error'
            }
            AlertManager[alertMethod](message, 10000)
            $scope.updatePage()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.validatingPerimeterAsIs = false
        })
    }

    $scope.transformTemplate = {
        max_power: null,
        id_p_calendar: null,
        routing_tariff: null,
    }

    $scope.transformFields = {
        label: {
            type: 'label',
            label: `<span class="fa fa-warning red"></span> Attention cette fonction ne doit pas être appelée pendant la phase de validation de périmètre !`,
        },
        max_power: {
            hidden: (t) => !$scope.isAdmin,
            label: `Puissance max de fallback`,
            type: 'typeahead',
            limitTo: 15,
            enum: ContractConstants.ref.allPowers,
        },
        id_p_calendar: {
            hidden: (t) => !$scope.isAdmin,
            label: `Calendrier fournisseur de fallback`,
            type: 'select',
            enum: [{ value: 'BASE', label: 'BASE' }, { value: 'HPHC', label: 'HPHC' }],
        },
        routing_tariff: {
            hidden: (t) => !$scope.isAdmin,
            label: `FTA de fallback`,
            type: 'select',
            enum: ContractConstants.ref.ftas,
        },
    }

    $scope.transformPerimeter = (account) => {
        account.transformingValidationPerimeter = true
        return ApiUser.transformValidationPerimeter({ id_account: account.id, limit: 100, delay: 50, fallback: $scope.transformTemplate }).$promise
        .then((result) => {
            $scope.updatePage()
            ModalService.openModal({ type: 'resultModal', size: 'lg' }, { result })
        })
        .catch(ErrorCatcher)
        .finally(() => {
            account.transformingValidationPerimeter = false
        })
    }

    $scope.openJiraOverlay = () => ModalService.openModal({ type: 'jiraListModal', size: 'xlg' }, { myAccounts: $scope.accounts })

    $scope.openBankDetailsModal = (siret, validationMode) => {
        ModalService.openModal({ type: 'bankDetailsModal', size: 'lg', backdrop: 'static' },
            { category: siret, value: null, orgType: $scope.selectedOrgObject.type },
            (result) => {
                if (result && result.success) {
                    if (validationMode) {
                        _.remove($scope.response.sirets, { siret: siret.siret })
                    } else {
                        updateAccount()
                    }
                }
            })
    }

    MetaWatcher.watch('MNG_ACCOUNT_CHANGED', 'perimeterValidation', $scope, updateAccount)

    const activate = () => {
        $scope.updatePage()
    }

    activate()
})
